import { useDelegateDialog } from './logic/useDelegateDialog'
import { DelegateDialogVariant } from './types'
import { DelegateView } from './views/DelegateView'
import { SuccessView } from './views/SuccessView'
import { useCloseDialog } from '@/domain/state/dialogs/hooks'
import { DialogContentSkeleton } from '@/features/dialogs/common/components/skeletons/DialogContentSkeleton'
import { withSuspense } from '@/ui/utils/withSuspense'

export type DelegateDialogContainerProps = {
  successViewProceedText?: string
  successViewProceedAction?: () => void
  onSuccess?: () => void
} & DelegateDialogVariant

function DelegateDialogContentContainer(props: DelegateDialogContainerProps) {
  const { pageStatus, ...useDelegateDialogResult } = useDelegateDialog(props)
  const closeDialog = useCloseDialog()

  if (pageStatus.state === 'success') {
    return (
      <SuccessView
        proceedAction={props.successViewProceedAction ?? closeDialog}
        proceedLabel={props.successViewProceedText ?? 'Close'}
        {...useDelegateDialogResult}
      />
    )
  }

  return <DelegateView {...useDelegateDialogResult} />
}

const DelegateDialogContentContainerWithSuspense = withSuspense(DelegateDialogContentContainer, DialogContentSkeleton)
export { DelegateDialogContentContainerWithSuspense as DelegateDialogContentContainer }
